import { API_BASE_URL } from "src/config/apiBase";

export const FALLBACK_ADMISSION_CENTERS = [
    "Airoli",
    "Kandivali",
    "Naigaon",
    "Ghansoli",
    "Goregoan West",
];

/**
 * Parse JSON body; HTML error pages (404, nginx, etc.) return {} instead of throwing.
 * @param {Response} res
 * @returns {Promise<Record<string, unknown>>}
 */
export async function safeResponseJson(res) {
    const text = await res.text();
    if (!text || !text.trim()) return {};
    try {
        return JSON.parse(text);
    } catch {
        return {};
    }
}

/**
 * Prefer `/admission/centers` (same host as other admission APIs); fall back to `/admission-centers`.
 */
export const ADMISSION_CENTERS_PATHS = ["/admission/centers", "/admission-centers"];

/**
 * @param {"GET"|"PUT"} method
 * @param {string} token
 * @param {object} [body] for PUT
 * @returns {Promise<{ res: Response, data: Record<string, unknown> }>}
 */
export async function requestAdmissionCenters(method, token, body = undefined) {
    const headers = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    const opts = { method, headers };
    if (body !== undefined) opts.body = JSON.stringify(body);

    /** @type {{ res: Response, data: Record<string, unknown> } | null} */
    let last = null;
    for (const path of ADMISSION_CENTERS_PATHS) {
        const res = await fetch(`${API_BASE_URL}${path}`, opts);
        const data = await safeResponseJson(res);
        last = { res, data };
        if (res.status !== 404) return last;
    }
    return last;
}

/**
 * @param {string} token Bearer token
 * @returns {Promise<string[]>} Always returns a non-empty list (fallback if API missing or error).
 */
export async function fetchAdmissionCenters(token) {
    try {
        const { res, data } = await requestAdmissionCenters("GET", token);
        if (!res.ok) {
            return [...FALLBACK_ADMISSION_CENTERS];
        }
        const list = data.centers;
        return Array.isArray(list) && list.length > 0 ? list : [...FALLBACK_ADMISSION_CENTERS];
    } catch {
        return [...FALLBACK_ADMISSION_CENTERS];
    }
}
